export default {
  id: '64534345',
  type: 'spacer',
  category: 'other',
  content: {},
  settings: {},
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: {
    padding: '20px',
  },
}
